import { Outlet } from "react-router-dom";
import Nav2 from "../components/Navs/Nav2";
import Nav3 from "../components/Navs/Nav3";
import { Toaster } from "react-hot-toast";

const MainLayout = () => {
  return (
    <>
      <div
        dir="rtl"
        className="container-fluid px-0 App col-lg-12 iran  "
        style={{ width: "100%", height: "100%" }}
      >
        <div>
          <div>
            <Toaster position="bottom-left" reverseOrder={false} />
          </div>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default MainLayout;
